/**
 * 职业认证路由
 */
const routerCertified = {
  path: '/certified',
  name: 'Certified',
  redirect: '/certified/data-governance-engineer',
  meta: {
    title: '职业认证',
    needLogin: false,
    transitionName: 'router',
    isTopMenu: true,
    isFatherMenu: true,
  },
  component: () => import('@/pages/module-certified/index.vue'),
  children: [
    {
      path: 'data-governance-engineer',
      name: 'CertifiedFirst',
      meta: {
        title: '数据治理',
        intro: 'CDGA/CDGP数据治理认证',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-1.png',
      },
      component: () => import('@/pages/module-certified/CertifiedFirst.vue'),
    },
    {
      path: 'pay',
      name: 'CertifiedFirstPay',
      meta: {
        title: '职业认证支付',
        needLogin: true,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-certified/CertifiedFirstPay.vue'),
    },
    {
      path: 'camp/:id',
      name: 'CertifiedFirstCamp',
      meta: {
        title: '职业认证营地',
        needLogin: true,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-certified/CertifiedFirstCamp.vue'),
    },
    // {
    //   path: 'big-data-analyst',
    //   name: 'CertifiedSecond',
    //   meta: {
    //     title: '大数据分析师',
    //     intro: '工业和信息化人才培养工程',
    //     needLogin: false,
    //     transitionName: 'router',
    //     isTopMenu: true,
    //     icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-2.png',
    //   },
    //   component: () => import('@/pages/module-certified/CertifiedSecond.vue'),
    // },
    {
      path: 'big-data-analyst-pay/:id',
      name: 'CertifiedSecondPay',
      meta: {
        title: '职业认证支付',
        needLogin: true,
        transitionName: 'router',
        isTopMenu: false,
      },
      component: () => import('@/pages/module-certified/CertifiedSecondPay.vue'),
    },
    // {
    //   path: 'data-manage',
    //   name: 'CertifiedThree',
    //   meta: {
    //     title: 'DCMM数据管理师',
    //     intro: 'CDP数据管理认证',
    //     needLogin: false,
    //     transitionName: 'router',
    //     isTopMenu: true,
    //     icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-3.png',
    //     url: 'https://www.asktempo.com/rzzx/dcmm.html',
    //   },
    //   component: () => import('@/pages/module-certified/CertifiedSecond.vue'),
    // },
    {
      path: 'certified-curse',
      name: 'CertifiedCurse',
      meta: {
        title: '数字工程师',
        intro: '数字工程师',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-3.png',
        url: 'https://www.asktempo.com/rzzx/dcmm.html',
      },
      component: () => import('@/pages/module-certified-curse/CertifiedMain.vue'),
    },
    {
      path: 'certified-new',
      name: 'CertifiedNew',
      meta: {
        title: '数字新职业',
        intro: '数字新职业',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-3.png',
        url: 'https://www.asktempo.com/rzzx/dcmm.html',
      },
      component: () => import('@/pages/module-certified-new/CertifiedMain.vue'),
    },
    {
      path: 'certified-cpda',
      name: 'CertifiedCpda',
      meta: {
        title: '行业认证',
        intro: '行业认证',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-3.png',
        url: 'https://www.asktempo.com/rzzx/dcmm.html',
      },
      component: () => import('@/pages/module-certified-cpda/CertifiedMain.vue'),
    },
    {
      path: 'data-security',
      name: 'CertifiedDataSecurity',
      meta: {
        title: '数据安全',
        intro: 'CISP/NISP安全认证',
        needLogin: false,
        transitionName: 'router',
        isTopMenu: true,
        icon: 'https://zzsk-video-upload.oss-cn-beijing.aliyuncs.com/static/images/router/icon-3.png',
      },
      component: () => import('@/pages/module-certified-data-security/CertifiedMain.vue'),
    },
  ],
};

export default routerCertified;
